import app from 'flarum/forum/app';

/* ===== 网盘自动提取 ===== */
const NETDISK_DOMAINS = [
  'pan.baidu.com', 'alipan.com', 'drive.uc.cn', 'uc.cn',
  'lanzoup.com', 'lanzou', 'pan.quark.cn', '123pan.com',
  'cloud.189.cn', '189.cn', 'pan.xunlei.com', 'pan.weiyun.com', '115.com'
];

function isNetdiskUrl(href) {
  if (!href) return false;
  return NETDISK_DOMAINS.some((d) => href.indexOf(d) !== -1);
}

function extractNetdisks(root) {
  const items = [];
  root.querySelectorAll('a[href]').forEach((a) => {
    const href = a.getAttribute('href') || '';
    if (isNetdiskUrl(href)) {
      items.push({ href, label: (a.textContent || '').trim() || href });
    }
  });
  return items;
}

function extractCodes(root) {
  const codes = [];
  const text = root.textContent || '';
  const re = /提取码[:：]\s*([A-Za-z0-9]{2,10})/g;
  let m;
  while ((m = re.exec(text)) !== null) {
    codes.push(m[1]);
  }
  return codes;
}

function copyText(text) {
  const fallback = () => {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  };
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).then(() => true, fallback);
  }
  return Promise.resolve(fallback());
}

function flashBtn(btn, okText) {
  const old = btn.textContent;
  btn.textContent = okText;
  btn.disabled = true;
  setTimeout(() => {
    btn.textContent = old;
    btn.disabled = false;
  }, 1500);
}

function buildPanel(items, codes) {
  const panel = document.createElement('div');
  panel.className = 'NetdiskPanel';

  const title = document.createElement('div');
  title.className = 'NetdiskPanel-title';
  title.textContent = '网盘资源（自动提取，点击复制）';
  panel.appendChild(title);

  items.forEach((it, idx) => {
    const row = document.createElement('div');
    row.className = 'NetdiskPanel-row';

    const name = document.createElement('span');
    name.className = 'NetdiskPanel-name';
    name.textContent = it.label;
    row.appendChild(name);

    const linkBtn = document.createElement('button');
    linkBtn.type = 'button';
    linkBtn.className = 'Button Button--primary NetdiskPanel-btn';
    linkBtn.textContent = '复制链接';
    linkBtn.addEventListener('click', () => {
      copyText(it.href).then((ok) => flashBtn(linkBtn, ok ? '已复制' : '失败'));
    });
    row.appendChild(linkBtn);

    if (codes[idx]) {
      const codeBtn = document.createElement('button');
      codeBtn.type = 'button';
      codeBtn.className = 'Button NetdiskPanel-btn NetdiskPanel-code';
      codeBtn.textContent = '提取码 ' + codes[idx];
      codeBtn.addEventListener('click', () => {
        copyText(codes[idx]).then((ok) => flashBtn(codeBtn, ok ? '已复制' : '失败'));
      });
      row.appendChild(codeBtn);
    }

    panel.appendChild(row);
  });

  const allBtn = document.createElement('button');
  allBtn.type = 'button';
  allBtn.className = 'Button NetdiskPanel-btn NetdiskPanel-all';
  allBtn.textContent = '一键复制全部（链接+提取码）';
  allBtn.addEventListener('click', () => {
    const text = items
      .map((it, i) => it.label + ': ' + it.href + (codes[i] ? '  提取码:' + codes[i] : ''))
      .join('\n');
    copyText(text).then((ok) => flashBtn(allBtn, ok ? '已全部复制' : '失败'));
  });
  panel.appendChild(allBtn);

  return panel;
}

function scanAndInject() {
  document.querySelectorAll('.Post-body').forEach((body) => {
    if (body.querySelector('.NetdiskPanel')) return;
    const items = extractNetdisks(body);
    if (!items.length) return;
    const codes = extractCodes(body);
    body.insertBefore(buildPanel(items, codes), body.firstChild);
  });
}

app.initializers.add('djzycc-theme-resource', function () {
  let color = 'tech-blue';
  let cardBoards = '1';
  let cardPosts = '1';
  let downloadBtn = '1';
  try {
    const data = app.data || {};
    const attrs = (data.resources && data.resources[0] && data.resources[0].attributes) || data.attributes || {};
    const settings = data.settings || {};
    color = attrs['djzycc-theme-resource.color'] || settings['djzycc-theme-resource.color'] || 'tech-blue';
    cardBoards = attrs['djzycc-theme-resource.card_boards'] != null ? String(attrs['djzycc-theme-resource.card_boards']) : (settings['djzycc-theme-resource.card_boards'] != null ? String(settings['djzycc-theme-resource.card_boards']) : '1');
    cardPosts = attrs['djzycc-theme-resource.card_posts'] != null ? String(attrs['djzycc-theme-resource.card_posts']) : (settings['djzycc-theme-resource.card_posts'] != null ? String(settings['djzycc-theme-resource.card_posts']) : '1');
    downloadBtn = attrs['djzycc-theme-resource.download_btn'] != null ? String(attrs['djzycc-theme-resource.download_btn']) : (settings['djzycc-theme-resource.download_btn'] != null ? String(settings['djzycc-theme-resource.download_btn']) : '1');
  } catch (e) {
    // 读取失败时保持默认
  }
  const el = document.documentElement;
  el.setAttribute('data-theme', color);
  el.setAttribute('data-card-boards', cardBoards === '1' ? '1' : '0');
  el.setAttribute('data-card-posts', cardPosts === '1' ? '1' : '0');
  el.setAttribute('data-download-btn', downloadBtn === '1' ? '1' : '0');

  /* 网盘自动提取：监听 DOM 变化，路由切换后自动注入面板 */
  if (downloadBtn === '1') {
    scanAndInject();
    const observer = new MutationObserver(() => {
      clearTimeout(observer._t);
      observer._t = setTimeout(scanAndInject, 400);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
